import type {
  CareOptionType,
  RecipientType,
} from "~care/components/ui/LeadForm/CareSeekerShallowLeadForm/form-options";

import { identifyAnonymous, track } from "@homeinstead/analytics";

const LeadEvents = {
  LEAD_CREATED: "sf-lead-created",
};

export type LeadEventParams = Partial<{
  leadId: string;
  organizationNumber: number;
  selectedOptions: CareOptionType[];
  recipient: RecipientType;
}>;

const commonParams = () => {
  return {
    page_path: window.location.pathname,
    page_url: window.location.href,
  };
};

const commonLeadParams = ({
  leadId,
  organizationNumber,
  selectedOptions,
  recipient,
}: LeadEventParams) => {
  return {
    franchise_number: organizationNumber,
    lead_id: leadId,
    recipient,
    selected_options: selectedOptions,
  };
};

/*
 * @deprecated Please use trackedLeadEvent from @homeinstead/analytics instead
 */
// lead was created (client-side tracking - should also happen in the API)
export const trackLeadCreated = (leadParams: LeadEventParams) => {
  track(LeadEvents.LEAD_CREATED, {
    element_name: "schedule-call",
    event: LeadEvents.LEAD_CREATED,
    ...commonParams(),
    ...commonLeadParams(leadParams),
  });
};

/*
 * @deprecated Please use identifyLead from @homeinstead/analytics instead
 */
export const identifyLead = (leadIdentityParams: {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}) => identifyAnonymous(leadIdentityParams);
